import { Model, ModelProperty } from 'models/Model';
import { MessageType } from 'enums/MessageType';
import { ProgressMessageStatus } from 'enums/ProgressMessageStatus';

export class PushMessageModel extends Model<PushMessageModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'hubMessage', type: 'any' },
		{ name: 'messageType', type: 'MessageType' }
	];
	[key: string]: any;
	
	public hubMessage?: any;
	public messageType: MessageType;
	
	constructor(){
		super();
		this.hubMessage = undefined;
		this.messageType = 0;
		
	}
	getProperties(){
		return PushMessageModel.classProperties;
	}
}

export class ProgressMessageModel extends Model<ProgressMessageModel> {
	public static classProperties: ModelProperty[] = [

		{ name: 'referenceId', type: 'string' },
		{ name: 'status', type: 'ProgressMessageStatus' },
		{ name: 'total', type: 'number' },
		{ name: 'processed', type: 'number' }
	];
	[key: string]: any;

	public referenceId?: string;
	public status: ProgressMessageStatus;
	public total?: number;
	public processed?: number;

	constructor() {
		super();
		this.referenceId = undefined;
		this.status = 0;
		this.total = undefined;
		this.processed = undefined;

	}
	getProperties() {
		return ProgressMessageModel.classProperties;
	}
}
